<template>
    <div class="w-full h-20 bg-white z-10 pt-2 pr-4 flex-grow flex items-center justify-between">
        <div>
            <span class="font-bold pl-4 text-2xl md:text-4xl align-middle inline-block bg-gradient-to-r from-secondary to-primary bg-clip-text text-transparent h-[1.3em]">{{ title }}</span>
        </div>
        <div class="flex items-center space-x-4">
            <span v-if="user.user" class="hidden whitespace-nowrap text-lg font-bold sm:inline-block">{{ $t('Willkommen') }}, {{ user.user }}</span>
            <button v-else class="hidden sm:inline-block mr-4" @click="window.location.href = '/login'">{{ $t('Anmelden') }}</button>
            <div class="relative flex items-center">
                <button @click="toggleDropdown" class="focus:outline-none hover:!bg-none border-none" :aria-label="currentLanguage.label">
                    <img :src="currentLanguage.img" :alt="currentLanguage.label" class="w-12 h-8 object-cover shadow" />
                </button>
                <div v-if="dropdownOpen" class="absolute right-0 top-full mt-1 w-32 bg-white border rounded shadow-lg z-50 origin-top-right">
                    <ul>
                        <li v-for="lang in languages" :key="lang.code">
                            <button @click="selectLanguage(lang.code)" class="w-full flex items-center px-2 py-2 hover:bg-primary focus:bg-gray-200 focus:outline-none" :aria-label="lang.label">
                                <img :src="lang.img" :alt="lang.label" style="width:1.5em;height:1.5em;object-fit:cover;margin-right:0.5em;box-shadow:0 1px 4px #0002;" />
                                <span class="text-base">{{ lang.label }}</span>
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
            <font-awesome-icon icon="bars" class="inline-block sm:hidden text-3xl text-primary cursor-pointer ml-2" @click="$emit('toggleMenu')"/>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
export default {
    name: 'Header',
    props: ['title','user'],
    data() {
        return {
            window: window,
            languages: [
                { code: 'de', label: 'Deutsch', img: require('@/assets/flag-de.svg') },
                { code: 'en', label: 'English', img: require('@/assets/flag-en.svg') },
               // { code: 'tr', label: 'Türkçe', img: require('@/assets/flag-tr.svg') }
            ],
            dropdownOpen: false
        }
    },
    computed: {
        currentLanguage() {
            return this.languages.find(l => l.code === this.$i18n.locale) || this.languages[0];
        }
    },
    methods: {
        toggleDropdown() {
            this.dropdownOpen = !this.dropdownOpen;
        },
        selectLanguage(lang) {
            this.$i18n.locale = lang;
            localStorage.setItem('locale', lang);
            this.dropdownOpen = false;
        },
        handleClickOutside(event) {
            if (!this.$el.contains(event.target)) {
                this.dropdownOpen = false;
            }
        }
    },
    mounted() {
        document.addEventListener('click', this.handleClickOutside);
        // Restore persisted language
        const savedLang = localStorage.getItem('locale');
        if (savedLang && savedLang !== this.$i18n.locale) {
            this.$i18n.locale = savedLang;
        }
    },
    beforeUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
    }
}
</script>

